import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

export const useQRCodeImage = (code: string, size: number = 200): HTMLImageElement | null => {
  const [image, setImage] = useState<HTMLImageElement | null>(null)

  useEffect(() => {
    let cancelled = false

    QRCode.toDataURL(code, { width: size, margin: 1 }).then((url) => {
      if (cancelled) return
      const img = document.createElement('img')
      img.onload = () => {
        if (!cancelled) setImage(img)
      }
      img.src = url
    })

    return () => {
      cancelled = true
    }
  }, [code, size])

  return image
}
